import { DEVICE } from '@/shahrzad-assets/shared-constants/breakPoints'
import { dimens } from '@/shahrzad-assets/shared-constants/dimens'
import { css } from 'styled-components'

const isFooterVisible = ()=>window.localStorage.getItem('is_footer_visible') === 'true';

export const PaymentSection = css<any>`
  @media ${DEVICE.laptop} {
    position: absolute !important;
    bottom: ${dimens.WEB_VIEW_FOOTER_HEIGHT} !important;
    width: 100%;
    background: white;
    left: 0;
    right: 0;
  }
`

export const FixedPaymentSection = (isFooterVisible:boolean) => css<any>`
  ${PaymentSection}
  @media ${DEVICE.laptop} {
    position: fixed !important;
    bottom: ${isFooterVisible ? dimens.WEB_VIEW_FOOTER_HEIGHT: '0px'} !important;
    transition: bottom 0.3s ease-in-out;
    z-index: 2;
  }
  @media ${DEVICE.laptop} and (prefers-reduced-motion) {
    transition: none;
  }
`

export const MobileMaxWidth = css<any>`
  @media ${DEVICE.tablet} {
    max-width: 576px;
  }
`
